<template lang="pug">
.activity-overview
  WtTitle(card-title) Team Steps Overview
  WtStatRow(icon="orange-shoe" name="Total Steps:" :value="_.get(teamAggregateData, 'totalSteps', '- -').toLocaleString()")
  WtStatRow(icon="yellow-bar-chart" name="Average Steps:" :value="_.get(teamAggregateData, 'averageSteps', '- -').toLocaleString()")
  WtStatRow(v-if="coreProgramMeta.converter" icon="purple-rope" name="Total Activities:" :value="_.get(teamAggregateData, 'totalActivities', '- -').toLocaleString()")
  WtStatRow(v-if="coreProgramMeta.converter" icon="blue-bar-chart" name="Average Activities:" :value="_.get(teamAggregateData, 'averageActivities', '- -').toLocaleString()")
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtStatRow from "@@/WtStatRow/WtStatRow";
import WtTitle from "@@/WtTitle/WtTitle";

export default {
  name: "TeamActivityOverview",

  components: {
    WtStatRow,
    WtTitle
  },

  props: {
    team: {
      type: Object,
      default: () => {
        return {
          id: null,
          name: null,
          description: null,
          public: null,
          inviteOnly: null,
          logo: null,
          maxMembers: null,
          numMembers: null,
          initiationDate: null
        };
      }
    }
  },

  data() {
    return {
      teamAggregateData: []
    };
  },

  computed: {
    ...mapGetters("program", ["coreProgramMeta"])
  },

  async mounted() {
    this.teamAggregateData = await this.fetchTeamAggregate({
      teamId: this.team.id
    });
  },

  methods: {
    ...mapActions("teams", ["fetchTeamAggregate"])
  }
};
</script>

<style lang="sass" scoped></style>
